import Swiper from 'swiper';
import { Pagination } from 'swiper';
<template>
  <div class="home">
    <div class="banner">
      <el-carousel :height="bannerHeight" width="100%">
        <el-carousel-item v-for="(item, index) in imgs" :key="index">
          <img class="bannersImg" :src="item.url" alt="" style="width:100%;"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 服务与产品 -->
    <div class="servProduc">
      <p class="text">SERVICE&PRODUCTS</p>
      <div class="info">
        <div class="top">
          <p class="title">服务与产品</p>
          <p class="subTile">Service&Products</p>
        </div>
        <div class="products">
          <ul class="tabs">
            <li @click="checkCaseCurrent(1)" :class="caseCurrent == 1 ?'current':''">工程建设和服务</li>
            <li @click="checkCaseCurrent(2)" :class="caseCurrent == 2 ?'current':''">软件系统和产品</li>
            <li @click="checkCaseCurrent(3)" :class="caseCurrent == 3 ?'current':''">应用场景解决方案</li>
          </ul>
          <swiper :options="serviceSwiperOptions">
            <swiper-slide class="slide_bar" v-for="(item, index) in ServeProLsit" :key="index">
              <div style="height:500px;cursor: pointer;" @click="toServePro(item.cid)">
                <div class="img" style="height: 280px; background: #1b2245; color: white">
                  <img :src="`http://www.china-tillage.com:8000${item.pic}`" alt="" style="width:100%">
                </div>
                <div>
                  <p
                    style="
                      font-size: 20px;
                      font-family: PingFangSC, PingFangSC-Medium;
                      font-weight: 700;
                      text-align: justify;
                      color: #040f36;
                      line-height: 28px;
                      padding: 10px 0;
                    "
                  >
                    <!-- 泰立汇云机电管理系统 -->
                    {{item.title}}
                  </p>
                  <p
                    style="
                      font-size: 16px;
                      height: 172px;
                      font-family: PingFangSC, PingFangSC-Regular;
                      font-weight: 400;
                      text-align: justify;
                      font-size:16px;
                      color: #0f2161;
                      line-height: 24px;
                      overflow: hidden;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 7;
                    "
                    v-html="item.content"
                  >
                    <!-- 将建筑物内的机电系统集成到一个平台上进行集中管理和运营，并根据各建筑物的特征，
                    制定不同的节能运行策略，使设备自动节能运行，实现设备运行价值参数实时显示、设备能源管理、
                    远程控制及空气质量监测等功能，省人降本将建筑物内的机电系统集成到一个平台上进行集中管理和运营，并根据各建筑物的特征，
                    制定不同的节能运行策略，使设备自动节能运行将建筑物内的机电系统集成到一个平台上进行集中管理和运营，并根据各建筑物的特征，
                    制定不同的节能运行策略，使设备自动节能运行。 -->
                  </p>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="about">
      <p class="text">ABOUT US</p>
      <div class="info">
        <div class="top">
          <p class="title">关于我们</p>
          <p class="subTile">ABOUT US</p>
        </div>
        <div class="introduction">
          <p>
            四川泰立智汇科技有限公司成立于2005年，自成立以来，公司专注于建筑机电系统智能化建设与智慧化管理业务，
            致力于为客户提供高效领先的建筑全机电系统智慧建设与运营管理的产品与技术服务。
          </p>
          <p>
            公司持续开展自主研发，于2015年推出具有核心自主知识产权的“泰立汇云智慧机电管理系统”并成功推广应用。
            该系统通过物联网、云计算、大数据等信息技术，实现建筑机电系统的节能降耗（综合节能率20%—40%）和各系统全生命周期的智慧运营（
            集中管控、能源管理、健康管理、数据沉淀）等功能，从而大幅节省运营成本、人力成本，有效提高物业管理质量和效率。
            该系统技术水平经科技部权威机构鉴定为“国内领先”。
          </p>
          <el-button
            @click="toAboutUs()"
            type="primary"
            style="position: absolute; left: 45%; bottom: 10px"
            >了解更多<i class="el-icon-d-arrow-right el-icon--right"></i
          ></el-button>
        </div>
      </div>
    </div>
    <!-- 新闻中心 -->
    <div class="news">
      <p class="text">NEWS</p>
      <div class="info">
        <div class="top">
          <p class="title">新闻中心</p>
          <p class="subTile">NEWS</p>
        </div>
        <div class="newsList">
          <ul>
            <li v-for="(item,index) in newsList" :key="index">
              <div class="img"><img :src="`http://www.china-tillage.com:8000${item.pic}`" alt=""></div>
              <div class="introduce">
                <p class="title">{{item.title}}</p>
                <p class="subTitle">{{item.summary}}</p>
                <p class="date">{{item.gtmCreate}}</p>
              </div>
              <el-button class="toNewsDetail" type="primary" size="mini" @click="toNewsDetail(item.cid)">查看详情</el-button>
            </li>
            <!-- <li>
              <div class="img">123</div>
              <div class="introduce">
                <p class="title">喜贺公司获得三产协会先进单位称号</p>
                <p class="subTitle">2020年面对严峻复杂的形式特别是新冠肺炎疫情重大影响的挑战和考验，
                  四川...
                </p>
                <p class="date">2021-05-03</p>
              </div>
            </li>
            <li>
              <div class="img">123</div>
              <div class="introduce">
                <p class="title">喜贺公司获得三产协会先进单位称号</p>
                <p class="subTitle">2020年面对严峻复杂的形式特别是新冠肺炎疫情重大影响的挑战和考验，
                  四川...
                </p>
                <p class="date">2021-05-03</p>
              </div>
            </li>
            <li>
              <div class="img">123</div>
              <div class="introduce">
                <p class="title">喜贺公司获得三产协会先进单位称号</p>
                <p class="subTitle">2020年面对严峻复杂的形式特别是新冠肺炎疫情重大影响的挑战和考验，
                  四川...
                </p>
                <p class="date">2021-05-03</p>
              </div>
            </li> -->
          </ul>
          <el-button
            @click="toNewsCenter()"
            type="primary"
            style="position: absolute; left: 45%; bottom: 40px"
            >了解更多<i class="el-icon-d-arrow-right el-icon--right"></i
          ></el-button>
        </div>
      </div>
    </div>
    <!-- 案例中心 -->
    <div class="caseCenter">
      <p class="text">CASE</p>
      <div class="info">
        <div class="top">
          <p class="title">案例中心</p>
          <p class="subTile">CASE</p>
        </div>
        <div class="caseCenterList">
          <div class="caseSwiper">
            <swiper :options="caseCenterSwiperOptions">
              <swiper-slide v-for="(item, index) in caseCenter" :key="index">
                <div class="case">
                  <img :src="`http://www.china-tillage.com:8000${item.pic}`" alt="" style="width:100%;">
                  <div class="introduce" v-html="item.content">
                    <!-- 农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
                    智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区。 -->
                  </div>
                </div>
                <p class="title">{{item.title}}</p>
              </swiper-slide>
              
            </swiper>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { baseURL } from "../../../config.ts"
// const hostName = location.hostname
export default {
  name: "home",
  data() {
    return {
      imgs: [
        // { url: require("../../assets/home/banner1.jpg") },
        // { url: require("../../assets/home/banner2.jpg") },
        // { url: require("../../assets/home/banner3.jpg") },
        // { url: require("../../assets/home/banner4.jpg") },
        // { url: require("../../assets/home/banner5.jpg") },
      ],
      // 服务与产品  swiper配置
      serviceSwiperOptions: {
        // pagination: ".swiper-pagination",
        //循环
        loop: false,
        slidesPerView: 3,
        spaceBetween: 30,
        //每张播放时长3秒，自动播放
        // autoplay:2000,
        //滑动速度
        speed: 200,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // 案例中心  swiper配置
      caseCenterSwiperOptions: {
        // 参数选项,显示小点
        pagination: {
          el: '.swiper-pagination',
        },
        //循环
        loop: true,
        slidesPerView: 4,
        spaceBetween: 30,
        //每张播放时长3秒，自动播放
        autoplay:2000,
        //滑动速度
        speed: 200,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      caseCurrent: 1, //  案例中心tab切换高亮
      // 新闻中心
      newsList:[],
      // 服务与产品
      ServeProLsit:[],
      //案例中心 
      caseCenter:[], 
      // 案例中心
      baseURL:null,
      bannerHeight: "1000px",
    };
  },
  methods: {
    // 服务、产品、解决方案  tab切换
    checkCaseCurrent(index){
      this.caseCurrent = index
      if(index == 1){   // 服务
        this.$http.get(`${baseURL}/json/case/message`).then( (res)=>{
            this.ServeProLsit = res.data
          }
        ).catch((err)=>{
          console.log(err)
        })
      }else if(index == 2){ // 产品
        this.$http.get(`${baseURL}/json/case/product`).then( (res)=>{
            this.ServeProLsit = res.data
          }
        ).catch((err)=>{
          console.log(err)
        })
      }else if(index == 3){ // 解决方案
        this.$http.get(`${baseURL}/json/case/solution`).then( (res)=>{
            this.ServeProLsit = res.data
          }
        ).catch((err)=>{
          console.log(err)
        })
      }
    },
    // 获取banner图片
    getBannerImg(){
      this.$http.get(`${baseURL}/json/img?page=1&rows=100`).then( (res)=>{
          this.imgs = []
          res.data.map( e =>{
            this.imgs.unshift({
              url:`http://www.china-tillage.com:8000${e.pic}`
            })
          })
          // console.log(this.imgs,"123123")
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    // 初始化服务与产品数据
    getServeProLsit(){
      this.$http.get(`${baseURL}/json/case/message`).then( (res)=>{
          this.ServeProLsit = res.data
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    // 获取新闻中心数据
    getNewsLsit(){
      this.$http.get(`${baseURL}/json/new?page=1&rows=100`).then( (res)=>{
          // console.log(res,"新闻")
          res.data.map( (item,index) =>{
            if(index<=3){
              this.newsList.push(item)
            }
          })
          // this.newsList = res.data
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    // 案例中心
    getCasePark(){
      this.$http.get(`${baseURL}/json/case`).then( (res)=>{
          // console.log(res,"园区")
          this.caseCenter = res.data
        }
      ).catch((err)=>{
        console.log(err)
      })
    },

    // 跳转到关于我们
    toAboutUs(){
      this.$router.push({path:"/about"})
    },
    // 跳转到服务与产品
    toServePro(id){
      console.log(id)
      // this.$router.push({path:'/serve',query: { id: id}})
    },
    // 跳转到新闻中心
    toNewsCenter(){
      this.$router.push({path:"/news"})
    },
    // 跳转到新闻详情
    toNewsDetail(id){
      this.$router.push({path:'/newsDetail',query: { id: id}})
    }
  },
  created() {
    setTimeout(()=>{
      this.bannerHeight = document.getElementsByClassName("bannersImg")[0].scrollHeight + "px"
    },1000)
  },
  mounted() {
    this.getBannerImg()
    this.getNewsLsit()
    this.getServeProLsit()
    this.getCasePark()
    this.baseURL = baseURL
  },
  computed:{},
  components: {},
};
</script>
<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
  text-decoration: none;
}
.home {
  // background-color: #1c3ce0;
  .banner{
    width: 100%;
  }
  .servProduc {
    width: 100%;
    height: 870px;
    position: relative;
    background: #e6e5e5;
    // border: 1px solid blue;
    p.text {
      width: 100%;
      font-size: 100px;
      font-family: PingFangSC, PingFangSC-Medium;
      color: #ebebeb;
      font-weight: 500;
      letter-spacing: 10px;
      position: absolute;
      top: 110px;
    }
    .info {
      position: relative;
      // width: 60%;
      width: 1200px;
      height: 780px;
      padding: 120px 0% 0 0%;
      margin: 0 auto;
      .top {
        width: 100%;
        height: 140px;
        p.title {
          font-size: 60px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #3488ea;
          line-height: 84px;
        }
        p.subTile {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Light;
          font-weight: 300;
          color: #3488ea;
          line-height: 20px;
          letter-spacing: 8px;
        }
      }
      .products {
        width: 100%;
        height: 480px;
        position: relative;
        ul.tabs{
          width: 36%;
          padding: 0 34% 20px 34%;
          display: flex;
          justify-content: space-between;
          li{
            width: 120px;
            height: 32px;
            font-size: 14px;
            line-height: 32px;
            border: 1px solid #3488ea;
            border-radius:32px;
            color: #3488ea;
            cursor: pointer;
          }
          li.current{
            color: #ffffff;
            // background: #1b2245;
            background: #3488ea;
            box-shadow: 0px 0px 6px 0px #4b65e6; 
          }
        }
        .swiper-container {
          width: 100%;
          height: 100%;
        }
        .img{
          overflow: hidden;
          img{
            transition: all 0.2s;
          }
        }
        .slide_bar:hover img{
          transform: scale(1.1);
        }
      }
    }
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
      top: 450px !important;
      left: 40%;
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
      top: 450px !important;
      right: 40%;
    }
    .swiper-pagination-bullets{
      position: relative;
      top: 50px;
      .swiper-pagination-bullet{
        margin: 0 10px;
        border: 1px solid #818599;
        border-radius: 50%;
      }
      .swiper-pagination-bullet-active{
        background: #555f90;
      }
    }
  }
  .about {
    width: 100%;
    height: 900px;
    // padding: 0 20%;
    position: relative;
    background: #060e36;
    p.text {
      width: 100%;
      font-size: 100px;
      font-family: PingFangSC, PingFangSC-Medium;
      color: #232b51;
      font-weight: 500;
      letter-spacing: 38px;
      position: absolute;
      top: 110px;
    }
    .info {
      position: relative;
      // width: 60%;
      width: 1200px;
      height: 780px;
      padding: 120px 0% 0 0%;
      margin: 0 auto;
      .top {
        width: 100%;
        height: 140px;
        p.title {
          font-size: 60px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;
          line-height: 84px;
        }
        p.subTile {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Light;
          font-weight: 300;
          color: #ffffff;
          line-height: 20px;
          letter-spacing: 8px;
        }
      }
    }
    .introduction {
      height: 350px;
      padding-top: 20px;
      position: relative;
      // border: 1px solid red;
      p {
        text-indent: 2rem;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: justify;
        color: #ffffff;
        line-height: 28px;
        padding: 20px 0;
      }
    }
  }
  .news {
    width: 100%;
    height: 900px;
    position: relative;
    background: #e6e5e5;
    p.text {
      width: 100%;
      font-size: 100px;
      font-family: PingFangSC, PingFangSC-Medium;
      color: #ebebeb;
      font-weight: 500;
      letter-spacing: 38px;
      position: absolute;
      top: 110px;
    }
    .info {
      position: relative;
      // width: 60%;
      width: 1200px;
      height: 780px;
      padding: 120px 0% 0 0%;
      margin: 0 auto;
      .top {
        width: 100%;
        height: 140px;
        p.title {
          font-size: 60px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #3488ea;
          line-height: 84px;
        }
        p.subTile {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Light;
          font-weight: 300;
          color: #3488ea;
          line-height: 20px;
          letter-spacing: 8px;
        }
      }
      .newsList{
        height: 580px;
        position: relative;
        ul{
          height: 460px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          li{
            width: 49%;
            height: 200px;
            display: flex;
            justify-content: space-between;
            background: #ffffff;
            box-shadow: 0px 0px 6px 0px #e2e5e9; 
            cursor: pointer;
            position: relative;
            div.img{
              width: 250px;
              height: 100%;
              overflow: hidden;
              display: flex;
              align-items: center;
              img{
                width: 100%;
                // height: 100%;
                transition: all 0.2s;
              }
            }
            div.img:hover{
              img{
                transform: scale(1.1);
              }
            }
            .introduce{
              // flex: 1;
              width: 338px;
              height: 100%;
              p.title{
                width: 90%;
                height: 30px;
                padding: 10px 5%;
                font-size: 18px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: bold;
                text-align: left;
                color: #040f36;
                line-height: 22px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              p.subTitle{
                width: 90%;
                height: 90px;
                padding: 10px 5%;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: justify;
                color: #0f2161;
                line-height: 24px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                overflow: hidden;
              }
              p.date{
                width: 90%;
                height: 30px;
                padding: 8px 5%;
                font-size: 12px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: justify;
                color: #48517f;
                line-height: 30px;
              }
            }
            .toNewsDetail{
              position: absolute;
              right: 10px;
              bottom: 10px;
            }
          }
        }
      }
    }
  }
  .caseCenter {
    width: 100%;
    height: 900px;
    position: relative;
    background: #060e36;
    position: relative;
    border-bottom: 5px solid #172152;
    p.text {
      width: 100%;
      font-size: 100px;
      font-family: PingFangSC, PingFangSC-Medium;
      color: #232b51;
      font-weight: 500;
      letter-spacing: 38px;
      position: absolute;
      top: 110px;
    }
    .info{
      position: relative;
      // width: 60%;
      width: 1200px;
      height: 780px;
      padding: 120px 0% 0 0%;
      margin: 0 auto;
      .top {
        width: 100%;
        height: 140px;
        p.title {
          font-size: 60px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;
          line-height: 84px;
        }
        p.subTile {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Light;
          font-weight: 300;
          color: #ffffff;
          line-height: 20px;
          letter-spacing: 8px;
        }
      }
      .caseCenterList{
        height: 500px;
        ul.tabs{
          width: 40%;
          padding: 0 30%;
          display: flex;
          justify-content: space-between;
          li{
            width: 100px;
            height: 32px;
            font-size: 14px;
            line-height: 32px;
            border: 1px solid #555f90;
            border-radius:32px;
            color: #ccc;
            cursor: pointer;
          }
          li.current{
            color: #ffffff;
            background: #1b2245;
            box-shadow: 0px 0px 6px 0px #4b65e6; 
          }
        }
        .caseSwiper{
          height: 320px;
          padding-top: 80px;
          .case{
            width: 280px;
            height: 220px;
            position: relative;
            overflow: hidden;
            .introduce{
              position: absolute;
              width: 90%;
              height: 200px;
              padding: 10px 5%;
              background: transparent;
              top: 220px;
              transition: top 0.1s ease-out;
              font-size: 16px;
              text-indent: 16px;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              text-align: left;
              color: #ffffff;
              line-height: 22px;
              background-color: rgb(52,136,234,0.5);
              display: flex;
              align-items: center;
            }
          }
          .case:hover .introduce{
            top: 0px;
          }
          p.title{
            padding: 10px 0;
            color: #ffffff;
          }
        }
      }
    }
    .swiper-button-prev{
      width: 27px;
      height: 44px;
      // border: 1px solid red;
      left: -40px;
    }
    .swiper-button-next{
      width: 27px;
      height: 44px;
      // border: 1px solid red;
      right: -40px;
    }

    .swiper-pagination-bullets{
      position: relative;
      top: 50px;
      .swiper-pagination-bullet{
        margin: 0 10px;
        border: 1px solid #818599;
        border-radius: 50%;
      }
      .swiper-pagination-bullet-active{
        background: #555f90;
      }
    }
  }
  
  
  
}
</style>
